import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "currency-container" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "exchange-rates" }
const _hoisted_4 = {
  key: 0,
  class: "rates-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "rates-grid"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "currency-code" }
const _hoisted_8 = { class: "rate-value" }
const _hoisted_9 = { class: "card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "currency-card" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Добро пожаловать в МНОС!", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_divider, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "divider-text" }, "Курсы валют", -1)
              ])),
              _: 1
            }),
            (_ctx.loadingRates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_skeleton, {
                    rows: 2,
                    animated: ""
                  })
                ]))
              : (_ctx.exchangeRates.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangeRates, (rate) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: rate.currency,
                        class: "rate-item"
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getCurrencyFlagUrl(rate.currency),
                          alt: rate.currency,
                          class: "currency-flag"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(rate.currency), 1),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(rate.rate.toFixed(4)), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            onClick: _ctx.goToLogin,
            class: "login-button"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Войти в аккаунт ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}